import React from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'

import {
  formContainer,
  titleContainer,
  secondaryTitle,
  buttonContainer
} from './styles/LoginForm.style'

import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'

import * as validators from '../../utils/validators'

const ResetPasswordForm = ({
  onSubmit,
  userPhrase,
  isSubmitting,
  token,
  translation,
  lang,
  initialValues
}) => {
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const passwordLength = lang === 'pt-BR' ? validators.passwordLengthPT : validators.passwordLengthES
  const passwordConfirmation = lang === 'pt-BR' ? validators.passwordConfirmationPT : validators.passwordConfirmationES
  const { control, register, getValues, handleSubmit } = useForm({
    defaultValues: {
      fractal_id: '',
      token: '',
      secret_answer: '',
      password: '',
      passwordConfirmation: '',
      ...initialValues
    }
  })

  return (
    <form className={formContainer} onSubmit={handleSubmit(onSubmit)}>
      <header className={titleContainer}>
        <h2 className={secondaryTitle}>Utilize seu E-mail ou Fractal ID</h2>
      </header>

      <div>
        {!token && (
          <input type='hidden' {...register('fractal_id')} />
        )}

        {!token && (
          <div>
            <Input
              control={control}
              name='secret_answer'
              rules={{ validate: validators.composeValidators(required) }}
              placeholder={`${translation('resetPassword')['secretQuestion']}: ${userPhrase.name}`}
              type='text'
              block
            />
          </div>
        )}

        <div>
          <Input
            control={control}
            name='password'
            rules={{ validate: validators.composeValidators(required, passwordLength) }}
            placeholder={translation('resetPassword')['passwordPlaceholder']}
            type='password'
            block
          />
        </div>

        <div>
          <Input
            control={control}
            name='passwordConfirmation'
            rules={{ validate: validators.composeValidators(required, passwordConfirmation(getValues)) }}
            placeholder={translation('resetPassword')['confirmPasswordPlaceholder']}
            type='password'
            block
          />
        </div>
      </div>

      <div className={buttonContainer}>
        <Button
          type='submit'
          disabled={isSubmitting}
        >
          {translation('resetPassword')['sendButton']}
        </Button>
      </div>
    </form>
  )
}

ResetPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  userPhrase: PropTypes.object,
  token: PropTypes.string,
  isSubmitting: PropTypes.bool.isRequired,
  translation: PropTypes.func,
  lang: PropTypes.string,
  initialValues: PropTypes.object
}

const mapStateToProps = ({ passwordRecovery }, { token }) => {
  const fractalId = passwordRecovery.login ? { fractal_id: passwordRecovery.login } : {}
  const tokenData = token ? { token: token } : {}

  return {
    userPhrase: passwordRecovery.userPhrase,
    isSubmitting: passwordRecovery.isSubmitting,
    initialValues: {
      ...fractalId,
      ...tokenData
    }
  }
}

export default connect(mapStateToProps)(ResetPasswordForm)
